<script setup lang="ts">

import BaseButton from "@/core/components/base/BaseButton.vue";
</script>

<template>
  <div class="bg-white p-6 space-y-4">
    <div>
      <h1 class="text-2xl">
        Activez les modules disponibles
      </h1>
      <p>Pour améliorer l'efficacité et la rentabilité de votre officine !</p>
    </div>
    <div class="p-4 bg-secondary-lightest rounded-lg flex items-end justify-between">
      <div>
        <h2>Estimez vos revenus potentiels</h2>
        <p>Simulez vos gains en fonction du potentiel à réaliser sur chaque module.</p>
      </div>
      <div class="relative">
        <img
          src="@/assets/images/happy_calculator.png" alt="calculator"
          class="h-28 object-contain absolute -rotate-12 right-0 -top-[65px]"
        >
        <BaseButton primary density="comfortable" :to="{name: 'extensions-profitability'}">
          Estimer mes revenus potentiels
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
